export const TAG_APPEARANCE = {
  filled: 'filled',
  outlined: 'outlined',
}

export const TAG_HEIGHT = {
  height16: 16,
  height20: 20,
  height24: 24,
  height28: 28,
  height32: 32,
  height40: 40,
  height48: 48,
}

export const TAG_HEIGHT_CLASSNAME = {
  [TAG_HEIGHT.height16]: 'height16',
  [TAG_HEIGHT.height20]: 'height20',
  [TAG_HEIGHT.height24]: 'height24',
  [TAG_HEIGHT.height28]: 'height28',
  [TAG_HEIGHT.height32]: 'height32',
  [TAG_HEIGHT.height40]: 'height40',
  [TAG_HEIGHT.height48]: 'height48',
}

export const QA_NAME_TAG = 'Tag'

export const QA_NAME_TAG_REMOVE = 'tagRemoveControl'
